function initializeCustomDropdowns() {
  document.querySelectorAll('[data-dropdown]').forEach((dropdown) => {
    if (dropdown.dataset.bound === 'true') return;
    dropdown.dataset.bound = 'true';

    const toggle = dropdown.querySelector('[data-toggle]');
    const labelSpan = toggle.querySelector('.dropdown-label');
    const input = dropdown.querySelector('input[name="sort_by"]');
    const items = dropdown.querySelectorAll('.dropdown-item');

    let closeTimer = null;

    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      dropdown.classList.add('open');
    });

    dropdown.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        dropdown.classList.remove('open');
      }, 200);
    });

    items.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const value = item.getAttribute('data-value');
        const label = item.textContent.trim();

        input.value = value;
        if (labelSpan) labelSpan.textContent = label;

        items.forEach((el) => el.classList.remove('is-active'));
        item.classList.add('is-active');

        dropdown.classList.remove('open');

        input.closest('form').dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initializeCustomDropdowns);
function reInitAll() {
  console.log('reInitAll triggered');
  const productCards = document.querySelectorAll('.card-product-wrapper');
  let openModal = null;

  productCards.forEach(card => {
    const swiperContainer = card.querySelector('.product-media-slider');
    const paginationEl = card.querySelector('.swiper-pagination');
    const nextEl = card.querySelector('.swiper-button-next');
    const prevEl = card.querySelector('.swiper-button-prev');
    const mediaItems = card.querySelectorAll('.product-media-item');

    const swatchSliderContainer = card.querySelector('.swatch-slider');
    const swatchNextEl = card.querySelector('.swatch-button-next');
    const swatchPrevEl = card.querySelector('.swatch-button-prev');
    const swatches = card.querySelectorAll('.swatch-button');

    const variantInput = card.querySelector('input[name="id"]');
    const addToCartButton = card.querySelector('button.quick-add__submit');

    const sizeWrapper = card.querySelector('.card-product-sizes');
    const sizeOptionsContainer = card.querySelector('.size-options');

    const variantDataScript = card.querySelector('.variant-options-json');
    const optionCount = parseInt(card.dataset.optionsCount || '1');

    const parentGrid = card.closest('.grid__item');
    const defaultColor = parentGrid ? parentGrid.dataset.b4bColor : null;
    const formatColorKey = value => value ? value.toLowerCase().replace(/\s+/g, '-').replace('/', '-') : '';
    const initialGroupKey = formatColorKey(defaultColor);

    const modal = card.querySelector('.product-modal');
    const openBtns = card.querySelectorAll('.open-modal-button');
    const closeBtn = card.querySelector('.modal-close');

    // Add price container reference
    const priceContainer = card.querySelector('[data-price-container]');
    const originalPriceHTML = priceContainer?.innerHTML;

    // Modal logic
    if (openBtns.length && modal) {
      openBtns.forEach(openBtn => {
        let modalOpenTimeout;
        openBtn.addEventListener('click', e => {
          e.stopPropagation();
          clearTimeout(modalOpenTimeout);
          modalOpenTimeout = setTimeout(() => {
            if (openModal && openModal !== modal) {
              openModal.hidden = true;
            }
            card.classList.add('media-loading');
            modal.hidden = false;
            openModal = modal;
            setTimeout(() => {
              card.classList.remove('media-loading');
            }, 300);
          }, 100);
        });
      });

      closeBtn?.addEventListener('click', e => {
        e.stopPropagation();
        modal.hidden = true;
        openModal = null;
      });

      modal.querySelector('.modal-content')?.addEventListener('click', e => e.stopPropagation());
    }

    // Media Swiper
    if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
     const isRTL = document.documentElement.dir === 'rtl';
const mediaSwiper = new Swiper(swiperContainer, {
  slidesPerView: 1,
  centeredSlides: true,
  loop: false,
  spaceBetween: 10,
  pagination: { el: paginationEl, type: "progressbar" },
  navigation: { nextEl, prevEl },
  direction: 'horizontal',
  rtl: isRTL,
});


      function updateMediaStaticClass() {
        const visibleSlides = Array.from(mediaItems).filter(item => item.style.display !== 'none');
        swiperContainer.classList.toggle('swatch-static', visibleSlides.length <= 1);
      }

      function updateSlides(selectedGroup) {
        card.classList.add('media-loading');

        const newSlides = [];
        mediaItems.forEach(item => {
          const match =
            item.dataset.imageGroup === selectedGroup ||
            (!item.dataset.imageGroup && selectedGroup === 'default') ||
            (item.dataset.imageGroup === 'default' && !selectedGroup);

          item.style.display = match ? '' : 'none';
          if (match) {
            item.classList.add('swiper-slide');
            newSlides.push(item);
          } else {
            item.classList.remove('swiper-slide');
          }
        });

        if (newSlides.length) {
mediaSwiper.removeAllSlides();
mediaSwiper.appendSlide(isRTL ? [...newSlides].reverse() : newSlides); // Reverse for RTL
mediaSwiper.update();
mediaSwiper.slideTo(isRTL ? newSlides.length - 1 : 0, 0); // Fix slide start index
        }

        updateMediaStaticClass();
        setTimeout(() => card.classList.remove('media-loading'), 300);
      }

      // Swatch slider
      if (swatchSliderContainer && !swatchSliderContainer.swiper) {
        const swatchSlides = swatchSliderContainer.querySelectorAll('.swiper-slide');
        const swiperWrapper = swatchSliderContainer.querySelector('.swiper-wrapper');

        if (swatchSlides.length > 5) {
const isRTL = document.documentElement.dir === 'rtl';

new Swiper(swatchSliderContainer, {
  slidesPerView: 'auto',
  spaceBetween: 0,
  navigation: { nextEl: swatchNextEl, prevEl: swatchPrevEl },
  breakpoints: {
    0: { slidesPerView: 'auto' },
    768: { slidesPerView: 'auto' },
    1024: { slidesPerView: 'auto' },
    1200: { slidesPerView: 5 },
  },
  direction: 'horizontal',
  rtl: isRTL,
  on: {
    init: updateEdgeClasses,
    slideChange: updateEdgeClasses,
    reachBeginning: updateEdgeClasses,
    reachEnd: updateEdgeClasses,
  },
});


          function updateEdgeClasses(swiper) {
            if (!swiperWrapper) return;
            swiperWrapper.classList.toggle('no-more-left', swiper.isBeginning);
            swiperWrapper.classList.toggle('no-more-right', swiper.isEnd);
          }
        } else {
          swatchSliderContainer.classList.add('swatch-static');
          swatchNextEl?.style.setProperty('display', 'none');
          swatchPrevEl?.style.setProperty('display', 'none');
        }
      }

      function renderSizesForColor(selectedColor) {
        if (!variantDataScript || !sizeWrapper || !sizeOptionsContainer) return;
        try {
          const variants = JSON.parse(variantDataScript.textContent);
          const sizesForColor = variants.filter(v => v.color === selectedColor);
          while (sizeOptionsContainer.firstChild) {
            sizeOptionsContainer.removeChild(sizeOptionsContainer.firstChild);
          }
          sizeWrapper.hidden = false;

          const seen = new Set();
          sizesForColor.forEach(v => {
            if (seen.has(v.size)) return;
            seen.add(v.size);

            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'size-button';
            btn.textContent = v.size;
            btn.dataset.variantId = v.id;
            btn.disabled = !v.available;
            if (!v.available) btn.classList.add('unavailable');

            btn.addEventListener('click', () => {
              sizeOptionsContainer.querySelectorAll('.size-button').forEach(b => b.classList.remove('active'));
              btn.classList.add('active');

              if (variantInput) {
                variantInput.value = v.id;
              }

              if (addToCartButton) {
                addToCartButton.disabled = !v.available;
                addToCartButton.classList.toggle('disabled', !v.available);
              }

              // Update price when size is selected
              updatePriceForVariant(v.id);

              if (v.available && window.innerWidth >= 1024) {
                document.body.classList.add('media-loading');
                setTimeout(() => {
                  const form = card.querySelector('form.form');
                  if (form) {
                    form.requestSubmit();
                  }
                  setTimeout(() => document.body.classList.remove('media-loading'), 800);
                }, 50);
              }
            });

            sizeOptionsContainer.appendChild(btn);
          });

        } catch (err) {
          console.warn('Invalid variant-options-json');
          sizeWrapper.hidden = true;
        }
      }

// Money formatting function with SVG currency icon and discount percentage
function formatPriceWithDiscount(price, compareAtPrice) {
  const currencySVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39" style="width:1em;height:1em;vertical-align:middle;fill:currentColor;"><path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>`;

  // Format number with comma separators
  const formatNumber = (amount) => {
    return (amount / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  };

  // Calculate discount percentage
  const calculateDiscount = (price, compareAtPrice) => {
    const discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
    return discount > 0 ? `(${discount}%)` : '';
  };

  const formattedPrice = `${currencySVG} ${formatNumber(price)}`;
  
  if (compareAtPrice && compareAtPrice > price) {
    const formattedCompareAtPrice = `${currencySVG} ${formatNumber(compareAtPrice)}`;
    return `<span class="sale-price">${formattedPrice}</span><span class="strikethrough">${formattedCompareAtPrice}</span>`;
  }

  return formattedPrice;
}

// Modified updatePriceForVariant function
function updatePriceForVariant(variantId) {
  if (!variantDataScript || !priceContainer) return;
  
  try {
    const variants = JSON.parse(variantDataScript.textContent);
    const variant = variants.find(v => v.id.toString() === variantId.toString());
    
    if (variant) {
      const priceHTML = `
        <div class="price">
          ${formatPriceWithDiscount(variant.price, variant.compare_at_price)}
        </div>
      `;
      priceContainer.innerHTML = priceHTML;
    }
  } catch (err) {
    console.warn('Error updating price:', err);
    priceContainer.innerHTML = originalPriceHTML;
  }
}

      swatches.forEach(swatch => {
        swatch.addEventListener('click', () => {
          const selectedGroup = swatch.dataset.imageGroup;
          const variantId = swatch.dataset.variantId;
          const available = swatch.dataset.available === "true";

          swatches.forEach(s => s.classList.remove('active'));
          swatch.classList.add('active');

          if (variantInput) {   variantInput.value = variantId; }
          updateSlides(selectedGroup);
          
          // Update price when color changes
          updatePriceForVariant(variantId);
          // Update product URLs with selected variant
const productLinks = card.querySelectorAll('a[href*="/products/"]');
productLinks.forEach(link => {
  const baseUrl = link.href.split('?')[0];
  link.href = `${baseUrl}?variant=${variantId}`;
});

// Optional: Update wishlist button URL too
const wishlistBtn = card.querySelector('.wishlist_button');
if (wishlistBtn) {
  const baseWishlistUrl = wishlistBtn.dataset.url.split('?')[0];
  wishlistBtn.dataset.url = `${baseWishlistUrl}?variant=${variantId}`;
}


          const availabilityJson = card.querySelector('.variant-availability-json');
          let colorIsAvailable = true;
          if (availabilityJson) {
            try {
              const availabilityData = JSON.parse(availabilityJson.textContent);
              colorIsAvailable = availabilityData[selectedGroup] === true;
            } catch (e) {
              console.warn('Failed to parse availability JSON', e);
            }
          }

          if (addToCartButton) {
  addToCartButton.disabled = !colorIsAvailable;
  addToCartButton.classList.toggle('disabled', !colorIsAvailable);
}
          if (optionCount > 1) {
            renderSizesForColor(selectedGroup);
          }
        });
      });

      const initialSwatch = Array.from(swatches).find(swatch => {
        const label = swatch.getAttribute('aria-label');
        return label && formatColorKey(label) === initialGroupKey;
      });
      (initialSwatch || swatches[0])?.click();
    }
  });

  // Close modal on outside click
  document.addEventListener('click', function (e) {
    if (openModal) {
      const isInsideCard = e.target.closest('.card-product-wrapper');
      if (!isInsideCard) {
        openModal.hidden = true;
        openModal = null;
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  reInitAll(); // Initial load
});

// Handle dynamic content (e.g., when products are loaded via AJAX)
if (typeof Shopify === 'object') {
  Shopify.onInit = reInitAll;
}